const actions = {
  CHECK_AUTHORIZATION: 'CHECK_AUTHORIZATION',

  GROUP_LIST:'GROUP_LIST',
  GROUP_LIST_RESULT:'GROUP_LIST_RESULT',
  GROUP_FETCH_ID:'GROUP_FETCH_ID',
  GROUP_FETCH_LIST_ID:'GROUP_FETCH_LIST_ID',

  checkAuthorization: () => ({ type: actions.CHECK_AUTHORIZATION }),

  GroupRead:(info)=>({
      type: actions.GROUP_LIST,
      payload:{info,page:1}
  }),
  onPageChange: (info, page) => ({
    type: actions.GROUP_LIST,
    payload: { info, page }
  }),
  groupListSuccess: (exportresult,result,success,total_count,page) => ({
   type: actions.GROUP_LIST_RESULT,
   exportresult,
   result,
   success,
   total_count,
   page
 }),
 groupfetchBYId:(listid)=>({
   type: actions.GROUP_FETCH_ID,
   payload:{listid}
 }),
 groupListById: (result,success) => ({
  type: actions.GROUP_FETCH_LIST_ID,
  result,
  success
}),
};
export default actions;
